/* @ngInject */
const blEssieuxExcel = (
  excelUtils,
  excelStyles,
  types
) => {
  const self = {}

  const firstRow = 19

  self.generate = (sale, axletreeIds, options) => {
    return excelUtils.getWorkbook('blEssieux')
      .then((workbook) => {
        const sheet = workbook.sheet(0)
        self.setHeader(sheet, sale, axletreeIds)
        self.setBody(sheet, sale.wagons, axletreeIds)
        return workbook.outputAsync({
          type: '',
        })
      })
      .catch((err) => {
        console.error(err.message || err)
        throw err
      })
  }

  self.download = (sale, options) => {
    return self.generate(sale, options)
      .then((blob) => {
        excelUtils.downloadWorkbook(blob, 'BL Essieux')
      })
      .catch((err) => {
        console.error(err.message || err)
        throw err
      })
  }

  self.setHeader = (sheet, sale, axletreeIds) => {
    self.getHeaderCells(sale, axletreeIds).forEach(cellInfo => {
      excelUtils.setCell(sheet, cellInfo)
    })
  }

  self.getHeaderCells = (_sale, _axletreeIds) => {
    return [{
      name: 'B8',
      value: _sale.date,
      type: types.date,
      style: { fontSize: 11, },
    }, {
      name: 'D16',
      value: _axletreeIds.length || 0,
      type: types.integer,
      style: { fontSize: 11, },
    },]
  }

  self.setBody = (sheet, wagons, axletreeIds) => {
    const axletrees = []
    wagons.forEach(wagon => {
      axletrees.push(
        ...wagon.axletrees
          .filter(axletree => axletreeIds.indexOf(axletree.id) >= 0)
      )
    })

    for (let i = 0; i < axletrees.length; i++) {
      const axletree = axletrees[i]

      self.getBodyCells(axletree, i).forEach(cellInfo => {
        excelUtils.setCell(sheet, cellInfo)
      })

      sheet.row(i + firstRow).height(24)
    }

    self.getFooterCells(axletrees.length).forEach(cellInfo => {
      excelUtils.setCell(sheet, cellInfo)
    })
  }

  self.getBodyCells = (_axletree, _index) => {
    const currentRow = firstRow + _index

    return [{
      name: `A${currentRow}`,
      style: excelStyles.blCell(),
    }, {
      name: `B${currentRow}`,
      value: _axletree.wagonId,
      type: types.wagonId,
      mergeRange: `B${currentRow}:C${currentRow}`,
      style: excelStyles.blCell(),
    }, {
      name: `D${currentRow}`,
      value: _axletree.position,
      mergeRange: `D${currentRow}:E${currentRow}`,
      style: excelStyles.blCell(),
    }, {
      name: `F${currentRow}`,
      value: _axletree.number,
      style: excelStyles.blCell(),
    }, {
      name: `G${currentRow}`,
      value: _axletree.type,
      mergeRange: `G${currentRow}:H${currentRow}`,
      style: excelStyles.blCell(),
    },]
  }

  self.getFooterCells = (_rowIndex) => {
    const lastLine = firstRow + _rowIndex + 1

    return [{
      name: `A${lastLine}`,
      value: `Fait à Morsbach, le 10 avril 2019`,
      mergeRange: `A${lastLine}:C${lastLine}`,
      style: excelStyles.blEndArray(),
    }, {
      name: `A${lastLine + 1}`,
      value: `Pour SGM, Damien`,
      mergeRange: `A${lastLine + 1}:C${lastLine + 1}`,
      style: excelStyles.blEndArray(),
    }, {
      name: `D${lastLine + 1}`,
      value: `Pour`,
      mergeRange: `D${lastLine + 1}:H${lastLine + 1}`,
      style: excelStyles.blEndArray(),
    },]
  }

  return self
}
export default blEssieuxExcel



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/services/excel/scrapping/blEssieuxExcel.service.js